<template>
  <div>
    <div class="d-flex justify-end">
      <v-btn
        @click="showAddDialog = true"
        small
        outlined
      >
        <v-icon>mdi-plus</v-icon>
        Add map
      </v-btn>
      <v-btn
        @click="showCreateDialog = true"
        small
        outlined
        class="ml-2"
      >
        <v-icon>mdi-plus</v-icon>
        Create map base
      </v-btn>
    </div>
    <v-dialog
      v-model="showAddDialog"
      max-width="800"
    >
      <CreateLeagueMap />
    </v-dialog>
    <v-dialog
      v-model="showCreateDialog"
      max-width="800"
    >
      <CreateMapBase />
    </v-dialog>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex'
import CreateMapBase from '@/components/tiimi_admin/league/map/CreateMapBase.vue'
import CreateLeagueMap from '@/components/tiimi_admin/league/map/CreateLeagueMap.vue'

export default {
  components: { CreateLeagueMap, CreateMapBase },
  data: () => ({
    showAddDialog: false,
    showCreateDialog: false
  })
}
</script>